var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShake(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M55.09 23.81a7.37 7.37 0 0 0 7.26-8.52 7.5 7.5 0 0 0-7.48-6.19H17.45A7.5 7.5 0 0 0 10 15.29a7.37 7.37 0 0 0 7.26 8.52h8.88A5.14 5.14 0 0 1 31.25 29h-8.11a7.5 7.5 0 0 0-7.48 6.19 7.37 7.37 0 0 0 7.26 8.52h3.55a4.78 4.78 0 0 1 4.78 4.78h-2a7.36 7.36 0 0 0-7.35 7.35h0a7.37 7.37 0 0 0 7.35 7.35h14.44a7.37 7.37 0 0 0 7.31-7.4h0a7.37 7.37 0 0 0-7.35-7.35h-2.54a4.78 4.78 0 0 1 4.78-4.78h3.4a7.5 7.5 0 0 0 7.48-6.19A7.38 7.38 0 0 0 49.51 29h-8.4a5.15 5.15 0 0 1 5.15-5.14Z",
    style: {
      fill: "#fff",
      stroke: "#1d1d1b",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    },
    className: "cls-1"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShake);
export default __webpack_public_path__ + "static/media/SHAKE.f2d5336f.svg";
export { ForwardRef as ReactComponent };